<header class="header clearfix">
  <div class="header__logo">
    <img src="assets/logo-blue.png" alt="logo">
  </div>
  <app-account></app-account>
  <app-balances></app-balances>
</header>
